// Module
var code = `
    <h2 class="section-header">Machine specific</h2>
    <form name="\$ctrl.machineSpecificForm">
        <table class="table">
            <thead>
            <tr>
                <th></th>
                <th>Property</th>
                <th>Value</th>
            </tr>
            </thead>
            <tbody>
            <td>1.</td>
            <td>Client machine code:</td>
            <td>
                <input required
                    type="text"
                    ng-model="\$ctrl.cmc"
                    ng-minlength="1"
                    ng-maxlength="16"/>
            </td>
            </tbody>
        </table>
        <div class="security-machine-specific__control-buttons buttons">
            <button
                type="submit"
                class="btn btn-success"
                ng-disabled="\$ctrl.machineSpecificForm.\$invalid"
                ng-click="\$ctrl.save()">
                Save changes
            </button>
        </div>
    </form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/security-machine-specific/security-machine-specific.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;